
<div class="pipeline-search-filter-wrapper">
	<div class="pipeline-search-sort">
		<slot name="searchAndSort" />
	</div>
	<div class="pipeline-filter-stat">
		<div class="p-filters-wrapper">
			<slot name="filters" />
		</div>
		<div v-if="$slots['stats']" class="p-stats-wrapper">
			<PipelineFilterSeparator />
			<slot name="stats" />
		</div>
		<div v-if="$slots['actions']" class="p-actions-wrapper">
			<PipelineFilterSeparator />
			<slot name="actions" />
		</div>
	</div>
</div>
